import { render, staticRenderFns } from "./InteractiveDataResults.vue?vue&type=template&id=63b379b1&scoped=true&"
import script from "./InteractiveDataResults.vue?vue&type=script&lang=ts&"
export * from "./InteractiveDataResults.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b379b1",
  null
  
)

export default component.exports